import {
  Box,
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
  Typography,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import {
  ECommissionEvaluationSummaryStatus,
  ITendersControlPanelSummary,
} from 'types/tender'

const StyledTable = styled(Table)(() => ({
  borderCollapse: 'collapse',
  width: '100%',
  '& th, & td': {
    border: '1px solid #dddddd !important',
  },
  '& th': {
    fontWeight: '600',
    whiteSpace: 'nowrap',
  },
  '& .MuiTableCell-root': {
    paddingLeft: '12px',
    paddingRight: '12px',
  },
}))

const StyledBox = styled(Box)(() => ({
  width: '15px',
  height: '15px',
  borderRadius: '50%',
}))

type Props = {
  controlPanelSummary: ITendersControlPanelSummary
}

export const CommissionEvaluationSummaryTable = ({ controlPanelSummary }: Props) => {
  const { t } = useTranslation()

  return (
    <>
      <Divider flexItem />
      <Typography variant="h6">{t('commission-evaluation-members')}</Typography>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer>
          <StyledTable
            size="small"
            sx={{ minWidth: 650, borderCollapse: 'collapse' }}
          >
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell>{t('commission-member-name')}</TableCell>
                <TableCell>{t('position')}</TableCell>
                <TableCell>{t('decision')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {controlPanelSummary.commissionEvaluationSummaryList.map(
                (member, index) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell scope="row">
                      <StyledBox
                        sx={{
                          background:
                            member.status ===
                            ECommissionEvaluationSummaryStatus.ACCEPTED
                              ? 'green'
                              : member.status ===
                                  ECommissionEvaluationSummaryStatus.REJECTED
                                ? '#FA4931'
                                : 'gray',
                        }}
                      />
                    </TableCell>
                    <TableCell scope="row">{member.memberFullName}</TableCell>
                    <TableCell scope="row">{member.memberPosition || ''}</TableCell>
                    <TableCell scope="row">{member.decisionNote || ''}</TableCell>
                  </TableRow>
                )
              )}
            </TableBody>
          </StyledTable>
        </TableContainer>
      </Paper>
      <Box sx={{ display: 'flex', gap: '20px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <StyledBox sx={{ background: 'green' }} />
          <Typography sx={{ fontSize: '14px' }}>{t('approved-purchase')}</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <StyledBox sx={{ background: '#FA4931' }} />
          <Typography sx={{ fontSize: '14px' }}>{t('declined-purchase')}</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <StyledBox sx={{ background: 'gray' }} />
          <Typography sx={{ fontSize: '14px' }}>
            {t('in-execution-purchase')}
          </Typography>
        </Box>
      </Box>
    </>
  )
}
